import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material";

const useResponsive = () => {
  const isExtraSmall = useMediaQuery(({ breakpoints }: Theme) => breakpoints.down("sm"));
  const isMobile = useMediaQuery(({ breakpoints }: Theme) => breakpoints.down("md"));
  const isTablet = useMediaQuery(({ breakpoints }: Theme) => breakpoints.only("md"));
  const isDesktop = useMediaQuery(({ breakpoints }: Theme) => breakpoints.up("lg"));

  return {
    isExtraSmall,
    isMobile,
    isTablet,
    isDesktop,
  };
};

export default useResponsive;
